import { basePageWrap } from '../BasePage';
import { useRouter } from 'next/router';
import styles from './ArtistListPage.module.scss';
import PropTypes from 'prop-types';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Hero from '../../components/Hero';
import ArtistCardList from '../../components/ArtistCardList/ArtistCardList';
import SingleChooser from '../../components/SingleChooser';
import Pagination from '../../components/Pagination';
import FormInputField from '../../components/FormInputField/FormInputField';
import { useEffect, useState } from 'react';
import Button from '../../components/Button';

const ArtistListPage = ({ settings = {
        hero: {},
        footer: {},
    }, hero, data = {} }) => {
    const router = useRouter();
    const PAGE_ITEMS_LIMIT = 9;
    const [searchValue, setSearchValue] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const searchedValue = router?.query?.search;

    useEffect(() => {
        if (router?.query?.search) {
            const querySearch = router.query.search;
            setSearchValue(querySearch);
        }
    }, [router?.query?.search]);

    useEffect(() => {
        if (data) {
            setIsLoading(false);
        }
    }, [data]);

    const setArgument = (url, value, paramName, resetPagination = false) => {
        const _url = new URL(url, 'https://dummy.url');
        if (value) {
            _url.searchParams.set(paramName, value);
        } else {
            _url.searchParams.delete(paramName);
        }
        if (resetPagination) {
            _url.searchParams.delete('p');
        }
        return _url.pathname + _url.search;
    };

    const handleCountryOnChange = (e) => {
        setIsLoading(true);
        router.replace(
            setArgument(window.location, e, 'country', true),
            undefined,
            { scroll: false }
        );
    };

    const handlePaginationOnChange = (e) => {
        setIsLoading(true);
        router.replace(setArgument(window.location, e, 'p', false), undefined, {
            scroll: true,
        });
    };

    const handleClearSelection = () => {
        setIsLoading(true);
        router.replace(
            setArgument(window.location, null, 'country', true),
            undefined,
            { scroll: false }
        );
    };

    const handleSearch = () => {
        setIsLoading(true);
        router.replace(
            setArgument(window.location, searchValue, 'search', true),
            undefined,
            { scroll: false }
        );
    };

    const handleClearSearch = () => {
        setIsLoading(true);
        setSearchValue('');
        router.replace(
            setArgument(window.location, null, 'search', true),
            undefined,
            { scroll: false }
        );
    };

    const formattedMatchesText = (totalMatches) => {
        const matchText = totalMatches === 1 ? 'match' : 'matches';
        return `${totalMatches} ${matchText} found for "${searchedValue}"`;
    };

    return (
        <div className={styles['ArtistListPage']}>
            <Header {...settings.header} />
            <main>
                {hero && <Hero {...hero} />}
                <div className={styles['ArtistListPage__Container']}>
                    <div className={styles['ArtistListPage__Filter']}>
                        {data && data.countries && (
                            <SingleChooser
                                placeholder={
                                    data.country?.label
                                        ? data.country.label
                                        : 'Select country'
                                }
                                activeValue={data.country?.value}
                                onChange={handleCountryOnChange}
                                options={data.countries}
                                showClearButton={true}
                                onClick={handleClearSelection}
                            />
                        )}
                        <div className={styles['ArtistListPage__Search']}>
                            <FormInputField
                                type="text"
                                placeholder="Search artist or gear"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                isSearch
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSearch();
                                    }
                                }}
                                showClearButton={searchValue.length > 0}
                                onClear={handleClearSearch}
                            />
                        </div>
                    </div>
                    {searchedValue && (
                        <div className={styles['ArtistListPage__Matches']}>
                            {formattedMatchesText(data.totalItemsCount)}
                        </div>
                    )}

                    {isLoading && (
                        <ArtistCardList isLoading={true} items={[]} />
                    )}

                    {!isLoading && data.items && (
                        <ArtistCardList items={data.items} />
                    )}
                    {!isLoading && data.items && data.items.length === 0 && (
                        <div className={styles['ArtistListPage__NoResults']}>
                            No results found
                        </div>
                    )}
                    {!isLoading &&
                        data &&
                        !!data.totalPages &&
                        data.totalPages > 1 && (
                            <div
                                className={
                                    styles['ArtistListPage__Pagination']
                                }>
                                <Pagination
                                    totalPages={data.totalPages}
                                    currentPage={data.currentPage}
                                    itemsPerPage={PAGE_ITEMS_LIMIT}
                                    pageUrl={data.paginationBaseUrl}
                                    onPageChange={handlePaginationOnChange}
                                />
                            </div>
                        )}
                </div>
            </main>
            <Footer {...settings.footer} />
        </div>
    );
};

ArtistListPage.propTypes = {
    hero: PropTypes.object,
    footer: PropTypes.object,
    data: PropTypes.object,
};

export default basePageWrap(ArtistListPage);
